/**
 * 图片加载工具函数
 * 使用动态导入加载图片资源
 */

/**
 * 加载图片
 * @param {string} imagePath - 图片相对路径
 * @returns {Promise<string>} 返回图片的 URL
 */
export const loadImage = (imagePath) => {
  return new Promise((resolve, reject) => {
    if (!imagePath) {
      resolve('')
      return
    }
    if (imagePath.startsWith('http') || imagePath.startsWith('/')) {
      resolve(imagePath)
      return
    }
    // 使用动态导入加载图片
    import(`@/assets/${imagePath}`)
      .then(module => {
        resolve(module.default)
      })
      .catch(error => {
        console.warn(`Failed to load image: ${imagePath}`, error)
        // 返回默认图片
        // import('@/assets/product/1/img/1.png')
        //   .then(defaultModule => resolve(defaultModule.default))
        //   .catch(() => {
        //     console.error('Failed to load default image')
        //     resolve('')
        //   })
          resolve('')
      })
  })
}

/**
 * 批量加载图片
 * @param {Array<string>} imagePaths - 图片路径数组
 * @returns {Promise<Array<string>>} 返回图片 URL 数组（只包含成功加载的）
 */
export const loadImages = async (imagePaths) => {
  const promises = imagePaths.map(path => loadImage(path))
  const results = await Promise.allSettled(promises)

  // 只返回成功加载的图片
  return results
    .map((result, index) => {
      if (result.status === 'fulfilled' && result.value) {
        return result.value
      } else {
        console.warn(`Failed to load image: ${imagePaths[index]}`, result.reason)
        return null
      }
    })
    .filter(img => img !== null && img !== '')
}

/**
 * 预加载图片
 * @param {string} imagePath - 图片路径
 * @returns {Promise<void>}
 */
export const preloadImage = (imagePath) => {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => resolve()
    img.onerror = () => reject(new Error(`Failed to preload image: ${imagePath}`))
    img.src = imagePath
  })
}

export default {
  loadImage,
  loadImages,
  preloadImage,
}
